import { useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { AgentContext } from '../Context/AgentContext';

const Agent = () => {
  const context = useContext(AgentContext);
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getAgents();
    };
    getData();
  }, [search]);

  const getAgents = async () => {
    setLoading(true);
    await get(
      `/agent${search}`,
      (res) => {
        context.agents = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);

    await destroy(
      `/agent/${id}`,
      (res) => {
        success(` عوامل اجرایی "${modalRemoveObject?.side}" با موفقیت حذف شد.`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getAgents();
      },
      (err) => {
        error('حذف به علت خطا انجام نشد.');
        setRemoveLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست رده عوامل اجرایی '
          createBtnTitle='ایجاد عوامل اجرایی'
          createPath='/agent/create'
        />
        <Datatable
          data={context.agents?.data}
          editUrl='/agent/edit'
          meta={context.agents?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePAgentPath='/Agent'
          columns={['سمت']}
          rows={[{ name: 'side', type: 'string' }]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف عوامل اجرایی "${modalRemoveObject?.side}" مطمئن هستید ؟`}
      />
    </>
  );
};

export default Agent;
